import { API } from '@/api';
import type { SHORTCUT_KEYS } from '@/constants/shortcutKeys';
import type { NAVIGATION_KEYS } from '@/constants/navigationKeys';

export const classes = {
  canvas: 'flex h-screen w-screen overflow-hidden bg-aurora-mesh',
  frame:
    'grid min-h-0 flex-1 grid-cols-[auto_1fr] grid-rows-[auto_1fr] overflow-hidden bg-white/50 backdrop-blur-[34px]',
  content: 'min-h-0 min-w-0 overflow-auto',
};

export function getShortcut(
  e: KeyboardEvent
): keyof typeof SHORTCUT_KEYS | null {
  switch (e.key?.toLowerCase()) {
    case 'c':
      return '\\C';
    case 'e':
      return '\\E';
    default:
      return null;
  }
}

export function getNavigation(
  e: KeyboardEvent
): keyof typeof NAVIGATION_KEYS | null {
  switch (e.key?.toLowerCase()) {
    case 'd':
      return '/D';
    case 'r':
      return '/R';
    case 's':
      return '/S';
    default:
      return null;
  }
}

export function isIgnoredKey(e: KeyboardEvent) {
  return ['Shift', '/', '\\'].includes(e.key);
}

export async function fetchPracticeData(accountId: number) {
  const [practicePreferences, practiceUsers] = await Promise.all([
    API.Practices.fetchPracticePreferences(accountId),
    API.Practices.fetchPracticeUsers(accountId, {
      filters: [],
      pagination: { page: 1, pageSize: 100 },
    }),
  ]);
  return { practicePreferences, practiceUsers: practiceUsers.results };
}
